export default "__VITE_ASSET__Cu7sbg4E__"